export default __webpack_public_path__ + "static/media/dandelion-seeds-2483277_1920.e145ee8a.png";